/* eslint-disable simple-import-sort/imports */
import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { styled } from 'styled-components';

import { dataFaq } from 'pages/Home/Sections/Faq/dataFaq';

import { Reveal } from '../components/Motion';
import { Container, Eyebrow, Section, SectionHead, Title, v2 } from '../v2';

const Wrapper = styled(Section)`
  background: ${v2.bg};
  border-top: 1px solid ${v2.border};
`;

const List = styled.div`
  max-width: 820px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Item = styled.div`
  border-radius: 18px;
  border: 1px solid
    ${({ $open }) => ($open ? 'rgba(30, 150, 252, 0.45)' : v2.border)};
  background: ${({ $open }) => ($open ? v2.surfaceHover : v2.surface)};
  backdrop-filter: blur(8px);
  overflow: hidden;
  transition:
    border-color 0.3s ease,
    background 0.3s ease;
`;

const Question = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 26px;
  text-align: left;
  font-family: ${v2.fontDisplay};
  font-size: clamp(1rem, 1.4vw, 1.15rem);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${v2.text};
  line-height: 1.4;
`;

const IconWrap = styled(motion.span)`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid ${v2.borderStrong};
  background: ${({ $open }) => ($open ? v2.blue : 'transparent')};
  transition: background 0.3s ease;

  svg {
    width: 14px;
    height: 14px;
  }
`;

const Answer = styled(motion.div)`
  overflow: hidden;

  p {
    margin: 0;
    padding: 0 26px 24px;
    font-family: ${v2.fontBody};
    font-size: 15.5px;
    line-height: 1.7;
    color: ${v2.textMuted};
  }
`;

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 5v14M5 12h14"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);

const FaqV2 = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <Wrapper id="faq">
      <Container>
        <SectionHead>
          <Reveal>
            <Eyebrow $accent="orange">FAQ</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <Title>
              Häufige <span className="grad">Fragen</span>
            </Title>
          </Reveal>
        </SectionHead>
        <List>
          {dataFaq.map((faq, index) => {
            const open = openIndex === index;
            return (
              <Reveal key={faq.title} delay={index * 0.04}>
                <Item $open={open}>
                  <Question
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    aria-expanded={open}
                  >
                    {faq.title}
                    <IconWrap
                      $open={open}
                      animate={{ rotate: open ? 45 : 0 }}
                      transition={{ duration: 0.3, ease: v2.ease }}
                      style={{ color: open ? '#fff' : v2.textMuted }}
                    >
                      <PlusIcon />
                    </IconWrap>
                  </Question>
                  <AnimatePresence initial={false}>
                    {open && (
                      <Answer
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: v2.ease }}
                      >
                        <p>{faq.description}</p>
                      </Answer>
                    )}
                  </AnimatePresence>
                </Item>
              </Reveal>
            );
          })}
        </List>
      </Container>
    </Wrapper>
  );
};

export default FaqV2;
